import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SuccessModal from './SuccessModal';

const API_BASE_URL = 'https://www.testometer.in:8084/api';

const AddSkillModal = ({ isOpen, onClose, onSkillAdded }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      setError('Skill name is required');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const response = await axios.post(`${API_BASE_URL}/master-data/technical-skills`, formData);
      
      // Reset form
      setFormData({
        name: '',
        category: '',
        description: ''
      });
      
      // Notify parent component
      onSkillAdded(response.data);
      
      // Close modal
      onClose();

      setShowSuccessModal(true);
      setSuccessMessage('Skill added successfully!');
    } catch (error) {
      console.error('Error adding skill:', error);
      setError('Error adding skill. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        name: '',
        category: '',
        description: ''
      });
      setError('');
      onClose();
    }
  };

  useEffect(() => {
    let timer;
    if (showSuccessModal) {
      timer = setTimeout(() => setShowSuccessModal(false), 3000);
    }
    return () => clearTimeout(timer);
  }, [showSuccessModal]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New Technical Skill</h2>
          <button 
            onClick={handleClose} 
            className="modal-close"
            disabled={loading}
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label className="form-label">Skill Name *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="input-field"
              placeholder="e.g., React, Java, AWS"
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Category</label>
            <select
              value={formData.category}
              onChange={(e) => setFormData({...formData, category: e.target.value})}
              className="input-field"
              disabled={loading}
            >
              <option value="">Select Category</option>
              <option value="Programming Languages">Programming Languages</option>
              <option value="Frameworks">Frameworks</option>
              <option value="Databases">Databases</option>
              <option value="Tools">Tools</option>
              <option value="Cloud Platforms">Cloud Platforms</option>
              <option value="Manual Testing">Manual Testing</option>
              <option value="Automation Testing">Automation Testing</option>
              <option value="API Tools">API Tools</option>
              <option value="Version Control/CI/Build Tool">Version Control/CI/Build Tool</option>
              <option value="Web Automation">Web Automation</option>
              <option value="Defect Tracking Tools">Defect Tracking Tools</option>
              <option value="Other">Other</option>
            </select>
          </div>
          
          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              className="input-field textarea-field"
              placeholder="Brief description of the skill..."
              rows="3"
              disabled={loading}
            />
          </div>
          
          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add Skill'}
            </button>
          </div>
        </form>
      </div>
      <SuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} message={successMessage} />
    </div>
  );
};

export default AddSkillModal; 